import React, { useEffect } from 'react'
import styled from 'styled-components'

import Layout from '../components/layout'
import Head from '../components/head'
import Form from '../components/login'

import media from '../assets/styles/media'

import BackgroundImage from '../assets/images/login-background.png'

const Background = styled.div`
  margin-top: auto;
  order: 1;
  height: 500px;
  background: url(${BackgroundImage});
  background-size: cover;
  ${media.lg`
    background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 1)
      ),
      url(${BackgroundImage});
    background-size: cover;
    order: 0;
    width: 50%;
    height: 100%;
  `}
`

const LoginPage = ({}) => {
  return (
    <Layout row>
      <Head title="Login" />
      <Background />
      <Form />
    </Layout>
  )
}

export default LoginPage
